import React from "react";
import { PickersDay, pickersDayClasses } from "@mui/x-date-pickers/PickersDay";
import PropTypes from "prop-types";
export default function CustomPickerDay(props) {
  CustomPickerDay.propTypes = {
    date: PropTypes.any,
    selectedDates: PropTypes.any,
    pickersDayProps: PropTypes.any,
  };

  return (
    <PickersDay
      {...props}
      sx={{
        [`&&.${pickersDayClasses.selected}`]: {
          backgroundColor: "var(--palette-button)",
        },
        [`&&.${pickersDayClasses.today}`]: {
          border: "1px solid var(--palette-button)",
        },
        [`&&.${pickersDayClasses.root}`]: {
          backgroundColor: "#121212",
          color: "#fff",
        },
      }}
    />
  );
}
